import template from './statusIndicator.html';
import controller from './statusIndicator.controller';

let statusIndicatorComponent = {
  restrict: 'E',
  template,
  controller,
  bindings: {},
  controllerAs: 'vm'
};

export
default statusIndicatorComponent;



// WEBPACK FOOTER //
// ./app/components/statusIndicator/statusIndicator.component.js